import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_NAME = '怀旧游戏博物馆';
const SITE_URL = 'https://rgm.games';
const DEFAULT_IMAGE = `${SITE_URL}/icon512.png`;
const INDEX_ROBOTS = 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
const NOINDEX_ROBOTS = 'noindex, nofollow, noarchive';

const pageDefinitions = {
  '/': {
    title: '怀旧游戏博物馆',
    description: '怀旧游戏博物馆（RGM）是一个收录经典电子游戏和档案中国游戏史的非盈利项目，访问以在线玩数千怀旧游戏，或者翻阅我们的游戏史档案。',
    keywords: '怀旧游戏博物馆,电子游戏博物馆,游戏历史,游戏档案,老游戏在线玩,经典游戏在线玩,复古游戏',
  },
  '/games': {
    title: '经典游戏在线玩与怀旧游戏库 | 怀旧游戏博物馆',
    description: '按游戏平台与年代浏览近千款经典电子游戏，在电脑或手机浏览器免费在线玩红白机、街机、雅达利、Game Boy、DOS 等怀旧游戏。',
    keywords: '经典游戏在线玩,老游戏在线玩,红白机游戏,街机游戏,复古游戏,怀旧游戏库',
  },
  '/feed': {
    title: '怀旧游戏推荐与免费在线玩 | 怀旧游戏博物馆',
    description: '通过游戏流发现值得重玩的经典电子游戏，直接在浏览器免费在线游玩，并了解游戏作品、开发者与发行年代。',
  },
  '/archives': {
    title: '电子游戏历史档案与游戏资料 | 怀旧游戏博物馆',
    description: '浏览电子游戏逆向工程档案、中文玩家手写攻略、历史报纸报道等专题馆藏，为游戏史、平台史与玩家文化研究提供中文资料。',
    keywords: '电子游戏历史,游戏档案,游戏博物馆,游戏史资料,游戏研究,游戏文化档案',
  },
  '/recondb': {
    title: 'ReconDB 电子游戏逆向工程档案 | 怀旧游戏博物馆',
    description: 'ReconDB 汇集早期电子游戏 ROM 的解汇编、反编译和逆向工程项目，为电子游戏历史、平台研究与批判性代码研究提供可检索资料。',
  },
  '/kamulewu': {
    title: '卡姆乐屋：中国早期玩家手写游戏攻略 | 怀旧游戏博物馆',
    description: '卡姆乐屋档案保存北京游戏店流传的手写游戏攻略、翻译与研究笔记，记录中文资料匮乏年代的中国玩家文化与社群记忆。',
  },
  '/newspaper-archive': {
    title: '电子游戏报纸档案与中国游戏史报道 | 怀旧游戏博物馆',
    description: '检索报纸中的电子游戏历史报道，以时间轴呈现电子游戏进入中国社会视野、公共讨论与日常生活的过程。',
  },
  '/oral-history': {
    title: '游戏口述史 | 怀旧游戏博物馆',
    description: '以个人视角记录人与游戏相遇、相伴与创造的故事，保存电子游戏背后真实而鲜活的记忆。',
    keywords: '游戏口述史,玩家记忆,游戏开发者,中国游戏史,游戏文化',
  },
  '/fc': {
    title: '枫城 2026 在线玩 | 怀旧游戏博物馆',
    description: '在线体验中文 Minecraft 地图「枫城 2026」预览版，查看网页版启动步骤与游玩说明。',
  },
  '/about': {
    title: '关于我们 | 怀旧游戏博物馆',
    description: '了解怀旧游戏博物馆的电子游戏保存、在线模拟、历史研究与公众参与工作。',
  },
  '/about/terms': {
    title: '使用条款 | 怀旧游戏博物馆',
    description: '怀旧游戏博物馆网站与馆藏资源的使用条款。',
  },
  '/enlist': {
    title: '参与电子游戏保存 | 怀旧游戏博物馆',
    description: '参与怀旧游戏博物馆的游戏整理、资料研究、测试与数字保存工作。',
  },
  '/feedback': {
    title: '反馈中心 | 怀旧游戏博物馆',
    description: '向怀旧游戏博物馆提交游戏运行、资料内容与网站体验反馈。',
  },
  '/search': {
    title: '找游戏 | 怀旧游戏博物馆',
    description: '记不起游戏名？输入记忆中的玩法、画面、角色或平台线索，查找可能的游戏，并申请将尚未收录的作品加入怀旧游戏博物馆。',
    keywords: '找游戏,寻找老游戏,忘记游戏名字,根据描述找游戏,游戏识别,怀旧游戏',
  },
};

const privatePageDefinitions = [
  { pattern: /^\/manage$/, title: '管理面板 | 怀旧游戏博物馆', description: '怀旧游戏博物馆内容管理面板。' },
  { pattern: /^\/manage-feedback-thread\//, title: '反馈管理 | 怀旧游戏博物馆', description: '查看并处理怀旧游戏博物馆的反馈记录。' },
  { pattern: /^\/login$/, title: '管理员登录 | 怀旧游戏博物馆', description: '怀旧游戏博物馆管理员登录。' },
  { pattern: /^\/add$/, title: '添加游戏 | 怀旧游戏博物馆', description: '向怀旧游戏博物馆添加游戏馆藏。' },
  { pattern: /^\/submit-game$/, title: '提交游戏 | 怀旧游戏博物馆', description: '访客游戏提交测试页面。' },
  { pattern: /^\/contribute-games(?:\/|$)/, title: '贡献游戏 | 怀旧游戏博物馆', description: '帮助怀旧游戏博物馆扩充游戏馆藏。' },
  { pattern: /^\/manage\/pending-game\//, title: '待审核游戏预览 | 怀旧游戏博物馆', description: '管理员预览待审核游戏提交。' },
  { pattern: /^\/update\//, title: '编辑游戏 | 怀旧游戏博物馆', description: '编辑怀旧游戏博物馆的游戏馆藏资料。' },
  { pattern: /^\/addplatform$/, title: '添加游戏平台 | 怀旧游戏博物馆', description: '添加游戏平台资料。' },
  { pattern: /^\/updateplatform\//, title: '编辑游戏平台 | 怀旧游戏博物馆', description: '编辑游戏平台资料。' },
  { pattern: /^\/game-details\//, title: '游戏详情 | 怀旧游戏博物馆', description: '查看游戏馆藏详情。' },
  { pattern: /^\/search\/track\//, title: '找游戏申请进度 | 怀旧游戏博物馆', description: '查看找游戏申请的处理进度。' },
  { pattern: /^\/search\/recent$/, title: '近期找游戏申请 | 怀旧游戏博物馆', description: '查看近期提交的找游戏申请。' },
];

const setMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
};

const setLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('link');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
};

export const Seo = ({
  title,
  description,
  canonical,
  image = DEFAULT_IMAGE,
  type = 'website',
  keywords,
  robots = INDEX_ROBOTS,
  jsonLd = [],
}) => {
  useEffect(() => {
    const canonicalUrl = canonical || `${SITE_URL}${window.location.pathname}`;
    document.documentElement.lang = 'zh-CN';
    document.title = title;

    setMeta('meta[name="description"]', { name: 'description', content: description });
    setMeta('meta[name="robots"]', { name: 'robots', content: robots });
    setMeta('meta[name="googlebot"]', { name: 'googlebot', content: robots });
    setMeta('meta[name="bingbot"]', { name: 'bingbot', content: robots });

    setMeta('meta[name="keywords"]', { name: 'keywords', content: keywords || '' });

    setMeta('meta[property="og:locale"]', { property: 'og:locale', content: 'zh_CN' });
    setMeta('meta[property="og:type"]', { property: 'og:type', content: type });
    setMeta('meta[property="og:site_name"]', { property: 'og:site_name', content: SITE_NAME });
    setMeta('meta[property="og:title"]', { property: 'og:title', content: title });
    setMeta('meta[property="og:description"]', { property: 'og:description', content: description });
    setMeta('meta[property="og:url"]', { property: 'og:url', content: canonicalUrl });
    setMeta('meta[property="og:image"]', { property: 'og:image', content: image });
    setMeta('meta[property="og:image:alt"]', { property: 'og:image:alt', content: title });
    setMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    setMeta('meta[name="twitter:title"]', { name: 'twitter:title', content: title });
    setMeta('meta[name="twitter:description"]', { name: 'twitter:description', content: description });
    setMeta('meta[name="twitter:image"]', { name: 'twitter:image', content: image });
    setMeta('meta[name="twitter:image:alt"]', { name: 'twitter:image:alt', content: title });

    setLink('link[rel="canonical"]', { rel: 'canonical', href: canonicalUrl });
    setLink('link[rel="alternate"][hreflang="zh-CN"]', { rel: 'alternate', hreflang: 'zh-CN', href: canonicalUrl });
    setLink('link[rel="alternate"][hreflang="x-default"]', { rel: 'alternate', hreflang: 'x-default', href: canonicalUrl });

    document.head.querySelectorAll('script[data-rgm-seo-jsonld]').forEach((node) => node.remove());
    const entries = Array.isArray(jsonLd) ? jsonLd : [jsonLd];
    entries.filter(Boolean).forEach((entry) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.dataset.rgmSeoJsonld = 'true';
      script.text = JSON.stringify(entry).replace(/</g, '\\u003c');
      document.head.appendChild(script);
    });
  }, [canonical, description, image, jsonLd, keywords, robots, title, type]);

  return null;
};

const SeoManager = () => {
  const location = useLocation();
  const path = location.pathname.replace(/\/+$/, '') || '/';
  const isGame = /^\/game\/\d+$/.test(path);
  const isPlatform = /^\/games\/platform\/[^/]+$/.test(path);
  const isArticle = /^\/newspaper-archive\/article\/\d+$/.test(path);
  const isOralHistoryArticle = /^\/oral-history\/[^/]+$/.test(path);
  const definition = pageDefinitions[path];
  const privateDefinition = privatePageDefinitions.find(({ pattern }) => pattern.test(path));

  if (definition) {
    return (
      <Seo
        {...definition}
        canonical={`${SITE_URL}${path === '/' ? '/' : path}`}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: definition.title,
          description: definition.description,
          url: `${SITE_URL}${path === '/' ? '/' : path}`,
          inLanguage: 'zh-CN',
          isPartOf: { '@type': 'WebSite', name: SITE_NAME, url: SITE_URL },
        }}
      />
    );
  }

  if (isArticle) {
    return (
      <Seo
        title={`电子游戏报纸档案与中国游戏史报道 | ${SITE_NAME}`}
        description={pageDefinitions['/newspaper-archive'].description}
        canonical={`${SITE_URL}/newspaper-archive`}
        robots={NOINDEX_ROBOTS}
      />
    );
  }

  if (isOralHistoryArticle) {
    return (
      <Seo
        title={`游戏口述史 | ${SITE_NAME}`}
        description={pageDefinitions['/oral-history'].description}
        canonical={`${SITE_URL}${path}`}
        type="article"
      />
    );
  }

  if (privateDefinition) {
    return (
      <Seo
        title={privateDefinition.title}
        description={privateDefinition.description}
        canonical={`${SITE_URL}${path}`}
        robots={NOINDEX_ROBOTS}
      />
    );
  }

  if (isGame || isPlatform) {
    return (
      <Seo
        title={`馆藏内容 | ${SITE_NAME}`}
        description="浏览怀旧游戏博物馆的电子游戏与历史档案。"
        canonical={`${SITE_URL}${path}`}
      />
    );
  }

  return (
    <Seo
      title={`页面不存在 | ${SITE_NAME}`}
      description="未能找到所请求的怀旧游戏博物馆页面。"
      canonical={`${SITE_URL}${path}`}
      robots={NOINDEX_ROBOTS}
    />
  );
};

export default SeoManager;
